import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { store } from "redux/store";
import { getHltInncodes } from "utils/CommonFunctions";
import { getUserName } from "utils/StoreUtils";
import { ON_BOARDING } from "utils/URLConstants";
import { fetchOnboardingQueries, setShowOnboardingWizardFromLibrary } from "./Onboarding.slice";

export const triggerOnboadingWizard = (dispatch: any) => {
  const state = store.getState();
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;
  const isOnboardingCompleted = state.onboardingResponse.isOnboardingCompleted;
  if (isImpersonated && !isOnboardingCompleted) {
    dispatch(
      setFeedbackDetails({
        variant: "warning",
        shouldShow: true,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: `'${getUserName()}' has never logged into BOOST. No data will display. `
      })
    );
  } else {
    const onBoardingData: any = {
      wizardType: ON_BOARDING,
      payload: {
        innCode: getHltInncodes(true)
      }
    };
    dispatch(fetchOnboardingQueries(onBoardingData));
    dispatch(setShowOnboardingWizardFromLibrary(true));
  }
};
